import ScalarMenuResources_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuResources.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarMenu/ScalarMenuResources.vue
var ScalarMenuResources_default = ScalarMenuResources_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuResources_default as default };

//# sourceMappingURL=ScalarMenuResources.vue.js.map